import { render, staticRenderFns } from "./LogoInvertedMainVersionSection.vue?vue&type=template&id=2e9829ec"
import script from "./LogoInvertedMainVersionSection.vue?vue&type=script&lang=ts"
export * from "./LogoInvertedMainVersionSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoInvertedMainVersionSection.vue?vue&type=style&index=0&id=2e9829ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports